import React from 'react';
import { Button, Form } from 'react-bootstrap';
import Select, { ValueType } from 'react-select';
import { CardCategory } from '../../models/customer-application';
import { CustomerLocation, isCustomerLocationRequired, LocationOption } from '../../models/customer-location';
import { CARD_APPLICATION_MAX_CARDS } from 'common/constants/cardApplication';

interface INewCustomerCardForm {
  cardName: string;
  monthlyLimit?: string;
  cardCategory?: CardCategory;
  isVirtual: boolean;
  customerLocationId?: number;
}

interface DiscountCardSectionProps {
  cards: INewCustomerCardForm[];
  setCards: (cards: INewCustomerCardForm[]) => void;
  saving: boolean;
  customerLocations?: CustomerLocation[];
  validated?: boolean;
}

export const DiscountCardSection: React.FC<DiscountCardSectionProps> = ({
  cards,
  setCards,
  saving,
  customerLocations = [],
  validated = false,
}) => {
  const hasCustomerLocations = isCustomerLocationRequired(customerLocations);
  const locationOptions = customerLocations.map(location => ({
    value: String(location.id),
    label: location.name ?? 'Nimetu osakond'
  }));

  return (
    <>
      {cards.map((card, idx) => (
        <div
          key={idx}
          className="customer-card-fields-group mb-2"
        >
          <div className="d-flex align-items-start mb-2">
            <div className="w-50">
              <Form.Label>Nimi</Form.Label>
              <Form.Control
                required
                minLength={1}
                value={card.cardName}
                onChange={e => {
                  const newCards = [...cards];
                  newCards[idx].cardName = e.target.value;
                  setCards(newCards);
                }}
                disabled={saving}
                type="text"
                placeholder={`Kaardi nimi ${idx + 1}`}
              />
              {!card.cardName && validated &&
                <div className="d-block text-right invalid-feedback">Kohustuslik väli</div>
              }
            </div>
            {hasCustomerLocations && (
              <div className="ml-2 w-50">
                <Form.Label>Osakond</Form.Label>
                <Select
                  inputId={`discount-card-location-${idx}`}
                  className={'select-terminal ' + (card.customerLocationId == null && validated ? 'invalid' : '')}
                  classNamePrefix="select"
                  options={locationOptions}
                  isDisabled={saving}
                  placeholder="Vali osakond"
                  noOptionsMessage={() => 'Vasted puuduvad'}
                  value={locationOptions.find(option => option.value === String(card.customerLocationId)) ?? null}
                  onChange={(option: ValueType<LocationOption>) => {
                    const selected = option as LocationOption | null;
                    const newCards = [...cards];
                    newCards[idx].customerLocationId = selected ? Number(selected.value) : undefined;
                    setCards(newCards);
                  }}
                />
                {card.customerLocationId == null && validated && (
                  <div className="d-block text-right invalid-feedback">Kohustuslik väli</div>
                )}
              </div>
            )}
            {cards.length > 1 && (
              <div className="ml-2 d-flex flex-column">
                <Form.Label className="invisible">&nbsp;</Form.Label>
                <div
                  className="icon__delete cursor-pointer d-flex align-items-center"
                  style={{ height: 'calc(1.5em + 0.75rem + 2px)' }}
                  onClick={() => {
                    setCards(cards.filter((_, i: number) => i !== idx));
                  }}
                  title="Eemalda kaart"
                  role="button"
                  tabIndex={0}
                />
              </div>
            )}
          </div>
        </div>
      ))}
      {cards.length < CARD_APPLICATION_MAX_CARDS && (
        <Button variant="primary" size="sm" className="mt-2" onClick={() => {
          setCards([...cards, { cardName: '', monthlyLimit: undefined, cardCategory: undefined, isVirtual: false }]);
        }} disabled={saving}>
          Lisa kaart
        </Button>
      )}
    </>
  );
};
